import {
  Center,
  Loader,
  type LoaderProps,
  Stack,
  Text,
  useMantineTheme,
  type TextProps,
} from '@mantine/core';
import { useEffect } from 'react';
import { loaderPresence } from './loaderPresence';

type LoadingIndicatorProps = {
  isFullPageLoading?: boolean;
  message?: string;
  size?: LoaderProps['size'];
  fontSize?: TextProps['size'];
};

export const LoadingIndicator = ({
  isFullPageLoading = false,
  message,
  fontSize = 'xl',
  size = 'lg',
  ...loaderProps
}: LoadingIndicatorProps & LoaderProps) => {
  const { primaryColor } = useMantineTheme();

  useEffect(
    () => loaderPresence.mount(isFullPageLoading ? 'full-page' : 'inline'),
    [isFullPageLoading]
  );

  const Loading = <Loader color={primaryColor} size={size} {...loaderProps} />;

  const WithMessage = (
    <Stack justify="center" align="center">
      {Loading}
      {message ? <Text size={fontSize}>{message}</Text> : null}
    </Stack>
  );

  if (isFullPageLoading)
    return (
      <Center sx={{ minHeight: '40vh', textAlign: 'center' }}>
        {WithMessage}
      </Center>
    );

  return message ? WithMessage : Loading;
};
